import { render } from "./ModalIllustration.vue?vue&type=template&id=1188cc94&scoped=true"
import script from "./ModalIllustration.vue?vue&type=script&lang=js"
export * from "./ModalIllustration.vue?vue&type=script&lang=js"

import "./ModalIllustration.vue?vue&type=style&index=0&id=1188cc94&lang=scss&scoped=true"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1188cc94"]])

export default __exports__